import './index.erb';
import './index.rb';
import 'jquery-countdown';
import module from './index.module.scss';


const formattedCounter = `
  <div class ="${module.counter}">
    <div class="${module.item}">
      <span class="${module.number}">%D</span>
      <span class="${module.label}">dias</span>
    </div>
    <div class="${module.colon}">:</div>
    <div class="${module.item}">
      <span class="${module.number}">%H</span>
      <span class="${module.label}">horas</span>
    </div>
    <div class="${module.colon}">:</div>
    <div class="${module.item}">
      <span class="${module.number}">%M</span>
      <span class="${module.label}">minutos</span>
    </div>
    <div class="${module.colon}">:</div>
    <div class="${module.item}">
      <span class="${module.number}">%S</span>
      <span class="${module.label}">segundos</span>
    </div>

  </div>
`;

const finishMsg = `<span class="${module.number}">AO VIVO</span>`;
let finalDateTime = $('#countdown-value').html();

if (!finalDateTime) {
  finalDateTime = '2019/01/01 00:00:00'
}

if (finalDateTime.length) {
  $('#countdown').countdown(finalDateTime, function (event) {
    $(this).html(event.strftime(formattedCounter));
    $('#countdown').html(event.strftime(formattedCounter));
  }).on('finish.countdown', function() {
    $(this).html(finishMsg);
    $('#countdown').html(finishMsg);
  });
}


